import script from "./ForgetPassword.vue?vue&type=script&setup=true&lang=js"
export * from "./ForgetPassword.vue?vue&type=script&setup=true&lang=js"

import "./ForgetPassword.vue?vue&type=style&index=0&id=60cf38c1&lang=scss"
import "./ForgetPassword.vue?vue&type=style&index=1&id=60cf38c1&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60cf38c1"]])

export default __exports__